import { Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';

import { Page } from '@components/page-containers/page-container';

import { usePermissions } from 'features/permissions';
import { CreateJob } from 'pages/CreateJobNew';
import { Access } from 'pages/CreateJobNew/Access/access';
import { ApplicationForm } from 'pages/CreateJobNew/ApplicationForm/application-form';
import { PreviewJob } from 'pages/CreateJobNew/preview-job';
import { Settings } from 'pages/CreateJobNew/settings';

export const JobsRouteConfig = () => {
  const { hasRolePermission } = usePermissions();

  return (
    <Page>
      <Routes>
        {hasRolePermission('job:create') && (
          <Fragment>
            <Route path="create" element={<CreateJob key="created" />} />
            <Route path=":jobId/edit/description" element={<CreateJob key="edit" />} />
            <Route path=":jobId/edit/form" element={<ApplicationForm key="application" />} />
            <Route path=":jobId/edit/access" element={<Access key="access" />} />
            <Route path=":jobId/edit/settings" element={<Settings key="settings" />} />
          </Fragment>
        )}
      </Routes>
    </Page>
  );
};

export const PreviewJobRouteConfig = () => {
  const { hasRolePermission } = usePermissions();

  return (
    <Page>
      <Routes>
        {hasRolePermission('job:create') && (
          <Route path="*" element={<PreviewJob key="preview" />} />
        )}
      </Routes>
    </Page>
  );
};
